import React from "react";

import Introduction1 from "../../new_Images/OtherComponents/16.png";
import youroffer1 from "../images/softtt.png";
import youroffer2 from "../images/dbb-1.png";
import youroffer3 from "../images/cloud.png";
import youroffer4 from "../images/ADDITIONAL SERVICE.png";
import bottomBanner from "../images/teamwork.jpg";

import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "../../App.css";

function About() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        <title>About Us | Clota Technology </title>
        <meta
          name="description"
          content="Learn about Clota Technology's mission to deliver innovative database, web, and cloud solutions tailored for business success."
        />
        <meta
          name="keywords"
          content="Clota Technology, About Clota, IT company, web development, database services, cloud solutions, software support"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Clota Technology" />
        <link rel="canonical" href="https://www.clotatech.com/About" />
      </Helmet>
      <div className="banner-container">
        <img src={Introduction1} className="banner-image" alt="Banner" />

        {/* Centered Content */}
        <div className="banner-content">
          <div className="banner-text">
            <h1 className="banner-heading">About Us </h1>
            {/* <p>Apply Now!</p> */}
          </div>
        </div>
      </div>

      {/* About Text */}
      <div className="mt-5 px-5 py-2">
        <div className="flex flex-column align-items-start">
          <i>
            <p>
              At CLOTA Technology, we provide innovative solutions in database
              technologies, web development, cloud maintenance, and software
              support to help businesses achieve their goals.
            </p>
            <p>
              Clota Technology services include expert SQL and NoSQL database
              design, implementation, and maintenance with certified DBAs
              boasting 15+ years of experience. We specialize in custom website
              and app creation, cloud services for migrations, monitoring, and
              security, as well as custom software tools for business
              automation. Our support and testing services ensure system
              stability and efficiency.
            </p>
          </i>
        </div>
      </div>

      {/* Our Offering Section */}

      <div
        className="px-5 py-2 text-center Text-Gradient"
        style={{ fontFamily: "rockwell" }}>
        <h1>
          <b>Our Offering</b>
        </h1>
      </div>


      <div className="grid px-5">
        {/* Web Development Card */}
        <div className="col-12 md:col-6 lg:col-3">
          <Card className="h-full shadow-2 border-round surface-card card-flex-offering">
            <div className="text-center">
              <img
                src={youroffer1}
                alt="Web Development"
                className="mb-3"
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
            </div>
            <div className="p-2 text-center card-offer-content">
              <h3>Web Development</h3>
              <p style={{ fontSize: "14px", marginBottom: "75px" }}>
                Clota Technology design and construct websites that are
                effective business channels using elegant aesthetics and
                out-of-the-box concepts.
              </p>

              <div className="card-footer-offering">
                <Link to="/WebDevelopment" onClick={scrollToTop}>
                  <Button
                    label="Learn More"
                    className="btn-styles"
                    severity="info"
                  />
                </Link>
              </div>
            </div>
          </Card>
        </div>

        {/* Cloud Services Card */}
        <div className="col-12 md:col-6 lg:col-3">
          <Card className="h-full shadow-2 border-round surface-card card-flex-offering">
            <div className="text-center">
              <img
                src={youroffer3}
                alt="Cloud Services"
                className="mb-3"
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
            </div>
            <div className="p-2 text-center card-offer-content">
              <h3>Cloud Services</h3>
              <p style={{ fontSize: "14px", marginBottom: "75px" }}>
                Our Cloud Services provide IT solutions including database,
                software, storage, and networking access via the internet.
              </p>

              <div className="card-footer-offering">
                <Link to="/CloudServices" onClick={scrollToTop}>
                  <Button
                    label="Learn More"
                    className="btn-styles"
                    severity="info"
                  />
                </Link>
              </div>
            </div>
          </Card>
        </div>

        {/* Database Services Card */}
        <div className="col-12 md:col-6 lg:col-3">
          <Card className="h-full shadow-2 border-round surface-card card-flex-offering">
            <div className="text-center">
              <img
                src={youroffer2}
                alt="Database Services"
                className="mb-3"
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
            </div>
            <div className="p-2 text-center card-offer-content">
              <h3>Database Services</h3>
              <p style={{ fontSize: "14px", marginBottom: "75px" }}>
                We provide full-cycle database solutions from design to
                maintenance using decades of expertise in SQL/NoSQL.
              </p>

              <div className="card-footer-offering">
                <Link to="/DatabaseServices" onClick={scrollToTop}>
                  <Button
                    label="Learn More"
                    className="btn-styles"
                    severity="info"
                  />
                </Link>
              </div>
            </div>
          </Card>
        </div>

        {/* Additional Services Card */}
        <div className="col-12 md:col-6 lg:col-3">
          <Card className="h-full shadow-2 border-round surface-card card-flex-offering">
            <div className="text-center">
              <img
                src={youroffer4}
                alt="Additional Services"
                className="mb-3"
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
            </div>
            <div className="p-2 text-center card-offer-content">
              <h3>Additional Services</h3>
              <p style={{ fontSize: "14px", marginBottom: "75px" }}>
                We provide a diverse range of additional services tailored to
                meet your unique challenges.
              </p>

              <div className="card-footer-offering">
                <Link to="/AdditionalServices" onClick={scrollToTop}>
                  <Button
                    label="Learn More"
                    className="btn-styles"
                    severity="info"
                  />
                </Link>
              </div>
            </div>
          </Card>
        </div>
      </div>
      {/* Final CTA */}
      <div
        className="mt-5 px-5 py-2 text-center Text-Gradient"
        style={{ fontFamily: "rockwell" }}>
        <h1>
          <b>
            For a reliable and professional technology partner, choose CLOTA
            TECHNOLOGY.
          </b>
        </h1>
      </div>
      {/* Bottom Banner */}
      <div className="py-2">
        <img
          src={bottomBanner}
          style={{ height: "350px", width: "100%", objectFit: "cover" }}
          alt="Teamwork Banner"
        />
      </div>
    </>
  );
}

export default About;
